<script>
    import Logout from '/public/components/users/Logout.svelte';   
</script>

<main>
    <div class="row justify-content-center mt-3 mb-3">
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-4 col-xxl-4">

            <Logout/>
            
        </div>
    </div>
</main>
